import jsPDF from "jspdf";

export const addPdfRecommendationBanner = (
  pdf: jsPDF,
  startY: number,
  heatOutput: string,
  airTemperatureLabel: string = "27°C"
) => {
  const disclaimerText = `
    According to the information you provided, our calculation indicates
that a minimum heat output of  ${heatOutput} kW @ Air ${airTemperatureLabel} heat pump is required.`;

  pdf.setFillColor(240, 240, 240);
  const disclaimerHeight =
    pdf.getTextDimensions(disclaimerText, { maxWidth: 190 }).h + 30;
  pdf.rect(0, startY, 210, disclaimerHeight, "F");

  pdf.setFontSize(10);
  pdf.setTextColor(0);
  pdf.setFont("NotoSans-Regular", "normal");
  pdf.text(disclaimerText, 102, startY + 10, {
    maxWidth: 190,
    align: "center",
  });

  pdf.setFont("NotoSans-Bold", "normal");
  pdf.setFillColor(255, 210, 0);
  pdf.setFontSize(20);
  pdf.rect(52, startY + 25, 102, disclaimerHeight - 10, "F");
  pdf.text("Recommended Models*", 104, startY + 42, {
    align: "center",
  });

  pdf.setFont("NotoSans-Regular", "normal");
  pdf.setFontSize(10);
  pdf.text("Models that match your selections", 104, startY + 46, {
    align: "center",
  });
};
